define('FSCModule.View',
	[
	'SCView',
	'psecomm_freeshipcompute_fscmodule.tpl',	
	'Backbone',
	'jQuery',
	'underscore'
    ],

	function FSCModuleView(
		SCViewComponent,
		psecomm_freeshipcompute_fscmodule_tpl,
		Backbone,
		jQuery,
		_
)
{
    'use strict';

	var SCView = SCViewComponent.SCView;

	function FSCModuleView(options) {
		var self = this;
		SCView.call(this);

		this.highPPFItem
		
		this.options = options || {};
		this.cart = this.options.cart;
		this.subtotal;

		this.cart.on('afterUpdateLine', function () {
			self.getDiffShipAmount();
		});

		this.cart.on('afterRemoveLine', function () {
			self.getDiffShipAmount();
		});

		this.cart.on('afterAddLine', function () {
			self.getDiffShipAmount();
		});
		

		this.container = options.container;

		this.userprofile = this.container.getComponent('UserProfile');

		this.environment = this.container.getComponent('Environment');

		this.template = psecomm_freeshipcompute_fscmodule_tpl;																																																																															
		
		this.isLoggedIn = false;
		this.freeShipAmount;
		this.highFreeShip;
		this.isOutOfStock = false;
		this.diffShipAmt;
		this.isFlagged = false;
		if (!this.environment.isPageGenerator()) {
			this.getDiffShipAmount();
		}
		
	}

	// Inherit parent instance methods.
	FSCModuleView.prototype = Object.create(SCView.prototype);

	// Restore the constuctor.
	FSCModuleView.prototype.constructor = FSCModuleView;

	FSCModuleView.prototype.getDiffShipAmount = function () {
		var self = this;
		self.userprofile.getUserProfile().then(function afterGetUserProfile(profile) {
			self.isLoggedIn = profile.isloggedin;

			if (!self.isLoggedIn) {
				return;
			}

			var freeShipField = _.findWhere(profile.customfields, { id: 'custentity_free_shipping_amount' });
			var highFreeShipField = _.findWhere(profile.customfields, { id: 'custentity_higher_free_shipping_amount' });

			self.freeShipAmount = freeShipField ? freeShipField.value : 0;
			self.highFreeShip = highFreeShipField ? highFreeShipField.value : 0;

			self.cart.getSummary().then(function(summary) {
				self.subtotal = summary.subtotal;

				self.cart.getLines().then(function(lines) {
					var ctr = 0;
					_.each(lines, function(line) {
						if (line.item.extras.custitem_higher_ppf_item) {
							ctr++;
						}
					});
					self.isFlagged = ctr > 0;

					var threshold = self.isFlagged ? self.highFreeShip : self.freeShipAmount;
					self.diffShipAmt = threshold - self.subtotal;

					self.render();
				});
			});
		});
	}

	FSCModuleView.prototype.getContext = function() {
		var nomessage = false
		if (this.diffShipAmt > 0){
			var nomessage = true
			var diffShipAmt2 = this.diffShipAmt.toFixed(2)
		}

		var freeShipMsg = this.environment.getConfig('extensions.fscmodule.FSCCustomNoteFree'),
			diffShipNote1 = this.environment.getConfig('extensions.fscmodule.FSCCustomNote1'),
			diffShipNote2 = this.environment.getConfig('extensions.fscmodule.FSCCustomNote2')

		return {
			diffShipNote1: diffShipNote1,
			freeShipMsg: freeShipMsg,
			diffShipNote2: diffShipNote2,
			isLoggedIn:this.isLoggedIn,
			diffShipAmt:diffShipAmt2,
			nomessage: nomessage
		}
	}

	FSCModuleView.prototype.validateContextDataRequest = function() {
		return true;
	}

	// Return the AMD constructor.
	return FSCModuleView;

});
